/*
 * @Author: mikey.zhaopeng
 * @Date: 2021-07-07 11:33:28
 * @Last Modified by: mikey.zhaopeng
 * @Last Modified time: 2021-07-07 11:36:49
 */

import YxTime from "./Time";
import PropType from "prop-types";
import { ITextBasePropTypes } from "../IpropType/basePropTypes";

YxTime.propTypes = {
  ...ITextBasePropTypes,
  format: PropType.string,
  isTimeZone: PropType.bool,
};

YxTime.defaultProps = {
  ////时间格式 dd/hh/mm/ss 默认为ss
  format: "YYYY-MM-DD HH:mm:ss",

  //时区功能，如果开启该功能,则将时间转为当前时区时间输出，输入的最好是UTC时间格式，且必须非时间戳，这样才能得到正确结果
  isTimeZone: false,

  //子节点
  children: "",
};
export default YxTime;



// WEBPACK FOOTER //
// ./src/yx-widget/component/YxText/Time/index.js